const topics = [
  { label: '久久视频', count: '2860部', hot: true },
  { label: '芒果视频', count: '1950部', hot: true },
  { label: '97视频', count: '1420部', hot: true },
  { label: '丝瓜视频', count: '1180部', hot: false },
  { label: '动作电影', count: '3260部', hot: true },
  { label: '热门电视剧', count: '4100部', hot: true },
  { label: '综艺节目', count: '890部', hot: false },
  { label: '动漫动画', count: '1560部', hot: false },
  { label: '海外剧集', count: '2340部', hot: true },
];

export default function Topics() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-white">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            大家都在关注的热门影视话题和标签
          </p>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((item, idx) => (
              <a
                key={idx}
                href="#topics"
                className={`group inline-flex items-center gap-2 px-5 py-2.5 rounded-full border transition-all duration-300 whitespace-nowrap ${
                  item.hot
                    ? 'bg-primary-50 border-primary-200 hover:bg-primary-100 hover:border-primary-300'
                    : 'bg-background-50 border-background-200 hover:bg-background-100 hover:border-background-300'
                }`}
              >
                <span
                  className={`text-sm font-medium ${
                    item.hot ? 'text-primary-700' : 'text-foreground-700'
                  }`}
                >
                  {item.label}
                </span>
                <span
                  className={`text-xs px-2 py-0.5 rounded-full ${
                    item.hot
                      ? 'bg-primary-200 text-primary-700'
                      : 'bg-background-200 text-foreground-400'
                  }`}
                >
                  {item.count}
                </span>
                {item.hot && (
                  <i className="ri-fire-line text-xs text-primary-500"></i>
                )}
              </a>
            ))}
          </div>
          <div className="text-center mt-8">
            <p className="text-xs text-foreground-400">
              以上话题数据基于近30天用户浏览和搜索统计，每日自动更新
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}